<template>
  <div class="pc-contextmenu__mask" v-show="visible"></div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  mounted () {
  },
  computed: {
    ...mapGetters('contextmenu', {
      visible: 'visible'
    })
  }
}
</script>

<style lang="scss">
.pc-contextmenu__mask {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2000;
}
</style>
